import { useIsMobile, getResponsiveImageUrl } from 'helpers/ui';
import { FallbackImage } from '@rcw/ui';
import '../news.scss';
import data from 'assets/data/News.json';

export function NewsHero() {
  const isMobile = useIsMobile(600);

  const { subtitle } = data.hero;
  const parts = subtitle.split('here');

  return (
    <div className='newHeroContainer'>
      <div className='newsHeroImageContainer'>
        <FallbackImage
          src={getResponsiveImageUrl(data.hero.imageUrl, data.hero.mobileImageUrl, isMobile)}
          fallbackSrc={data.hero.imageUrl}
          alt='News Hero'
        />
      </div>
      <div className='newHeroContainer_data' style={{ textAlign: 'center' }}>
        <p className='newHeroContainer_body'>{data.hero.subheader}</p>
        <h2 className='newHeroContainer_title proxima-nova-bold'>{data.hero.header}</h2>
        <p className='newHeroContainer_body'>
          {parts[0]}
          <a href='#news-articles'>here</a>
          {parts[1]}
        </p>
      </div>
    </div>
  );
}
